import { Component, OnInit } from '@angular/core';
import { Http, RequestOptions, Headers, URLSearchParams } from '@angular/http';

import { environment } from '../../environments/environment';

import { ApiService } from 'app/api.service';
import { LoaderService } from 'app/loader.service';

declare var $: any;
declare var alertify: any;

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {
  private Parse: any = require('parse');

  model: any = { };
  currentUser: any;

  // Set up the country list
  countries: any = [
    { "code" : "AF", "name" : "Afghanistan" },
    { "code" : "AX", "name" : "Åland Islands" },
    { "code" : "AL", "name" : "Albania" },
    { "code" : "DZ", "name" : "Algeria" },
    { "code" : "AS", "name" : "American Samoa" },
    { "code" : "AD", "name" : "Andorra" },
    { "code" : "AO", "name" : "Angola" },
    { "code" : "AI", "name" : "Anguilla" },
    { "code" : "AQ", "name" : "Antarctica" },
    { "code" : "AG", "name" : "Antigua and Barbuda" },
    { "code" : "AR", "name" : "Argentina" },
    { "code" : "AM", "name" : "Armenia" },
    { "code" : "AW", "name" : "Aruba" },
    { "code" : "AU", "name" : "Australia" },
    { "code" : "AT", "name" : "Austria" },
    { "code" : "AZ", "name" : "Azerbaijan" },
    { "code" : "BS", "name" : "Bahamas" },
    { "code" : "BH", "name" : "Bahrain" },
    { "code" : "BD", "name" : "Bangladesh" },
    { "code" : "BB", "name" : "Barbados" },
    { "code" : "BY", "name" : "Belarus" },
    { "code" : "BE", "name" : "Belgium" },
    { "code" : "BZ", "name" : "Belize" },
    { "code" : "BJ", "name" : "Benin" },
    { "code" : "BM", "name" : "Bermuda" },
    { "code" : "BT", "name" : "Bhutan" },
    { "code" : "BO", "name" : "Bolivia" },
    { "code" : "BA", "name" : "Bosnia and Herzegovina" },
    { "code" : "BW", "name" : "Botswana" },
    { "code" : "BV", "name" : "Bouvet Island" },
    { "code" : "BR", "name" : "Brazil" },
    { "code" : "IO", "name" : "British Indian Ocean Territory" },
    { "code" : "BN", "name" : "Brunei Darussalam" },
    { "code" : "BG", "name" : "Bulgaria" },
    { "code" : "BF", "name" : "Burkina Faso" },
    { "code" : "BI", "name" : "Burundi" },
    { "code" : "KH", "name" : "Cambodia" },
    { "code" : "CM", "name" : "Cameroon" },
    { "code" : "CA", "name" : "Canada" },
    { "code" : "CV", "name" : "Cape Verde" },
    { "code" : "KY", "name" : "Cayman Islands" },
    { "code" : "CF", "name" : "Central African Republic" },
    { "code" : "TD", "name" : "Chad" },
    { "code" : "CL", "name" : "Chile" },
    { "code" : "CN", "name" : "China" },
    { "code" : "CX", "name" : "Christmas Island" },
    { "code" : "CC", "name" : "Cocos (Keeling) Islands" },
    { "code" : "CO", "name" : "Colombia" },
    { "code" : "KM", "name" : "Comoros" },
    { "code" : "CG", "name" : "Congo" },
    { "code" : "CD", "name" : "Congo, The Democratic Republic of the" },
    { "code" : "CK", "name" : "Cook Islands" },
    { "code" : "CR", "name" : "Costa Rica" },
    { "code" : "CI", "name" : "Cote D'Ivoire" },
    { "code" : "HR", "name" : "Croatia" },
    { "code" : "CU", "name" : "Cuba" },
    { "code" : "CY", "name" : "Cyprus" },
    { "code" : "CZ", "name" : "Czech Republic" },
    { "code" : "DK", "name" : "Denmark" },
    { "code" : "DJ", "name" : "Djibouti" },
    { "code" : "DM", "name" : "Dominica" },
    { "code" : "DO", "name" : "Dominican Republic" },
    { "code" : "EC", "name" : "Ecuador" },
    { "code" : "EG", "name" : "Egypt" },
    { "code" : "SV", "name" : "El Salvador" },
    { "code" : "GQ", "name" : "Equatorial Guinea" },
    { "code" : "ER", "name" : "Eritrea" },
    { "code" : "EE", "name" : "Estonia" },
    { "code" : "ET", "name" : "Ethiopia" },
    { "code" : "FK", "name" : "Falkland Islands (Malvinas)" },
    { "code" : "FO", "name" : "Faroe Islands" },
    { "code" : "FJ", "name" : "Fiji" },
    { "code" : "FI", "name" : "Finland" },
    { "code" : "FR", "name" : "France" },
    { "code" : "GF", "name" : "French Guiana" },
    { "code" : "PF", "name" : "French Polynesia" },
    { "code" : "TF", "name" : "French Southern Territories" },
    { "code" : "GA", "name" : "Gabon" },
    { "code" : "GM", "name" : "Gambia" },
    { "code" : "GE", "name" : "Georgia" },
    { "code" : "DE", "name" : "Germany" },
    { "code" : "GH", "name" : "Ghana" },
    { "code" : "GI", "name" : "Gibraltar" },
    { "code" : "GR", "name" : "Greece" },
    { "code" : "GL", "name" : "Greenland" },
    { "code" : "GD", "name" : "Grenada" },
    { "code" : "GP", "name" : "Guadeloupe" },
    { "code" : "GU", "name" : "Guam" },
    { "code" : "GT", "name" : "Guatemala" },
    { "code" : "GG", "name" : "Guernsey" },
    { "code" : "GN", "name" : "Guinea" },
    { "code" : "GW", "name" : "Guinea-Bissau" },
    { "code" : "GY", "name" : "Guyana" },
    { "code" : "HT", "name" : "Haiti" },
    { "code" : "HM", "name" : "Heard Island and Mcdonald Islands" },
    { "code" : "VA", "name" : "Holy See (Vatican City State)" },
    { "code" : "HN", "name" : "Honduras" },
    { "code" : "HK", "name" : "Hong Kong" },
    { "code" : "HU", "name" : "Hungary" },
    { "code" : "IS", "name" : "Iceland" },
    { "code" : "IN", "name" : "India" },
    { "code" : "ID", "name" : "Indonesia" },
    { "code" : "IR", "name" : "Iran, Islamic Republic Of" },
    { "code" : "IQ", "name" : "Iraq" },
    { "code" : "IE", "name" : "Ireland" },
    { "code" : "IM", "name" : "Isle of Man" },
    { "code" : "IL", "name" : "Israel" },
    { "code" : "IT", "name" : "Italy" },
    { "code" : "JM", "name" : "Jamaica" },
    { "code" : "JP", "name" : "Japan" },
    { "code" : "JE", "name" : "Jersey" },
    { "code" : "JO", "name" : "Jordan" },
    { "code" : "KZ", "name" : "Kazakhstan" },
    { "code" : "KE", "name" : "Kenya" },
    { "code" : "KI", "name" : "Kiribati" },
    { "code" : "KP", "name" : "Democratic People's Republic of Korea" },
    { "code" : "KR", "name" : "Korea, Republic of" },
    { "code" : "XK", "name" : "Kosovo" },
    { "code" : "KW", "name" : "Kuwait" },
    { "code" : "KG", "name" : "Kyrgyzstan" },
    { "code" : "LA", "name" : "Lao People's Democratic Republic" },
    { "code" : "LV", "name" : "Latvia" },
    { "code" : "LB", "name" : "Lebanon" },
    { "code" : "LS", "name" : "Lesotho" },
    { "code" : "LR", "name" : "Liberia" },
    { "code" : "LY", "name" : "Libyan Arab Jamahiriya" },
    { "code" : "LI", "name" : "Liechtenstein" },
    { "code" : "LT", "name" : "Lithuania" },
    { "code" : "LU", "name" : "Luxembourg" },
    { "code" : "MO", "name" : "Macao" },
    { "code" : "MK", "name" : "Macedonia, The Former Yugoslav Republic of" },
    { "code" : "MG", "name" : "Madagascar" },
    { "code" : "MW", "name" : "Malawi" },
    { "code" : "MY", "name" : "Malaysia" },
    { "code" : "MV", "name" : "Maldives" },
    { "code" : "ML", "name" : "Mali" },
    { "code" : "MT", "name" : "Malta" },
    { "code" : "MH", "name" : "Marshall Islands" },
    { "code" : "MQ", "name" : "Martinique" },
    { "code" : "MR", "name" : "Mauritania" },
    { "code" : "MU", "name" : "Mauritius" },
    { "code" : "YT", "name" : "Mayotte" },
    { "code" : "MX", "name" : "Mexico" },
    { "code" : "FM", "name" : "Micronesia, Federated States of" },
    { "code" : "MD", "name" : "Moldova, Republic of" },
    { "code" : "MC", "name" : "Monaco" },
    { "code" : "MN", "name" : "Mongolia" },
    { "code" : "ME", "name" : "Montenegro" },
    { "code" : "MS", "name" : "Montserrat" },
    { "code" : "MA", "name" : "Morocco" },
    { "code" : "MZ", "name" : "Mozambique" },
    { "code" : "MM", "name" : "Myanmar" },
    { "code" : "NA", "name" : "Namibia" },
    { "code" : "NR", "name" : "Nauru" },
    { "code" : "NP", "name" : "Nepal" },
    { "code" : "NL", "name" : "Netherlands" },
    { "code" : "AN", "name" : "Netherlands Antilles" },
    { "code" : "NC", "name" : "New Caledonia" },
    { "code" : "NZ", "name" : "New Zealand" },
    { "code" : "NI", "name" : "Nicaragua" },
    { "code" : "NE", "name" : "Niger" },
    { "code" : "NG", "name" : "Nigeria" },
    { "code" : "NU", "name" : "Niue" },
    { "code" : "NF", "name" : "Norfolk Island" },
    { "code" : "MP", "name" : "Northern Mariana Islands" },
    { "code" : "NO", "name" : "Norway" },
    { "code" : "OM", "name" : "Oman" },
    { "code" : "PK", "name" : "Pakistan" },
    { "code" : "PW", "name" : "Palau" },
    { "code" : "PS", "name" : "Palestinian Territory, Occupied" },
    { "code" : "PA", "name" : "Panama" },
    { "code" : "PG", "name" : "Papua New Guinea" },
    { "code" : "PY", "name" : "Paraguay" },
    { "code" : "PE", "name" : "Peru" },
    { "code" : "PH", "name" : "Philippines" },
    { "code" : "PN", "name" : "Pitcairn" },
    { "code" : "PL", "name" : "Poland" },
    { "code" : "PT", "name" : "Portugal" },
    { "code" : "PR", "name" : "Puerto Rico" },
    { "code" : "QA", "name" : "Qatar" },
    { "code" : "RE", "name" : "Reunion" },
    { "code" : "RO", "name" : "Romania" },
    { "code" : "RU", "name" : "Russian Federation" },
    { "code" : "RW", "name" : "Rwanda" },
    { "code" : "SH", "name" : "Saint Helena" },
    { "code" : "KN", "name" : "Saint Kitts and Nevis" },
    { "code" : "LC", "name" : "Saint Lucia" },
    { "code" : "PM", "name" : "Saint Pierre and Miquelon" },
    { "code" : "VC", "name" : "Saint Vincent and the Grenadines" },
    { "code" : "WS", "name" : "Samoa" },
    { "code" : "SM", "name" : "San Marino" },
    { "code" : "ST", "name" : "Sao Tome and Principe" },
    { "code" : "SA", "name" : "Saudi Arabia" },
    { "code" : "SN", "name" : "Senegal" },
    { "code" : "RS", "name" : "Serbia" },
    { "code" : "SC", "name" : "Seychelles" },
    { "code" : "SL", "name" : "Sierra Leone" },
    { "code" : "SG", "name" : "Singapore" },
    { "code" : "SK", "name" : "Slovakia" },
    { "code" : "SI", "name" : "Slovenia" },
    { "code" : "SB", "name" : "Solomon Islands" },
    { "code" : "SO", "name" : "Somalia" },
    { "code" : "ZA", "name" : "South Africa" },
    { "code" : "GS", "name" : "South Georgia and the South Sandwich Islands" },
    { "code" : "ES", "name" : "Spain" },
    { "code" : "LK", "name" : "Sri Lanka" },
    { "code" : "SD", "name" : "Sudan" },
    { "code" : "SR", "name" : "Suriname" },
    { "code" : "SJ", "name" : "Svalbard and Jan Mayen" },
    { "code" : "SZ", "name" : "Swaziland" },
    { "code" : "SE", "name" : "Sweden" },
    { "code" : "CH", "name" : "Switzerland" },
    { "code" : "SY", "name" : "Syrian Arab Republic" },
    { "code" : "TW", "name" : "Taiwan" },
    { "code" : "TJ", "name" : "Tajikistan" },
    { "code" : "TZ", "name" : "Tanzania, United Republic of" },
    { "code" : "TH", "name" : "Thailand" },
    { "code" : "TL", "name" : "Timor-Leste" },
    { "code" : "TG", "name" : "Togo" },
    { "code" : "TK", "name" : "Tokelau" },
    { "code" : "TO", "name" : "Tonga" },
    { "code" : "TT", "name" : "Trinidad and Tobago" },
    { "code" : "TN", "name" : "Tunisia" },
    { "code" : "TR", "name" : "Turkey" },
    { "code" : "TM", "name" : "Turkmenistan" },
    { "code" : "TC", "name" : "Turks and Caicos Islands" },
    { "code" : "TV", "name" : "Tuvalu" },
    { "code" : "UG", "name" : "Uganda" },
    { "code" : "UA", "name" : "Ukraine" },
    { "code" : "AE", "name" : "United Arab Emirates" },
    { "code" : "GB", "name" : "United Kingdom" },
    { "code" : "US", "name" : "United States" },
    { "code" : "UM", "name" : "United States Minor Outlying Islands" },
    { "code" : "UY", "name" : "Uruguay" },
    { "code" : "UZ", "name" : "Uzbekistan" },
    { "code" : "VU", "name" : "Vanuatu" },
    { "code" : "VE", "name" : "Venezuela" },
    { "code" : "VN", "name" : "Viet Nam" },
    { "code" : "VG", "name" : "Virgin Islands, British" },
    { "code" : "VI", "name" : "Virgin Islands, U.S." },
    { "code" : "WF", "name" : "Wallis and Futuna" },
    { "code" : "EH", "name" : "Western Sahara" },
    { "code" : "YE", "name" : "Yemen" },
    { "code" : "ZM", "name" : "Zambia" },
    { "code" : "ZW", "name" : "Zimbabwe" }
  ];

  // Get today's date for the `birthDate` max value
  today = new Date();

  constructor(
    private http: Http,
    private apiService: ApiService,
    private loaderService: LoaderService
  ) {
    if (this.Parse.User.current()) {
      this.currentUser = this.Parse.User.current();
    }

    this.getUser();
  }

  ngOnInit() {
    this.loaderService.setLoading();
  }

  // Split the `shareSessionWith` into an array
  public shareSessionWithToArray(event) {
    this.model.preferences.notifications.shareSessionWith = event.split(",").map((item) => item.trim());
  }

  // Upload profile image
  public uploadProfileImage(event) {
    let headers = new Headers();
    let fileList: FileList = event.target.files;

    // Set the HTTP headers
    headers.append('X-Parse-Application-Id', environment.parse.appId);
    headers.append('X-Parse-javascript-Key', environment.parse.jsKey);
    if (this.apiService.Parse.User.current()) {
      headers.append('X-Parse-Session-Token', this.apiService.Parse.User.current().get('sessionToken'));
    }

    let options = new RequestOptions({ headers: headers });

    if (fileList.length > 0) {
      let file = fileList[0];

      // Set the `Content-Type` header to the type of the uploaded file
      headers.append('Content-Type', file.type);

      // POST to the files route with the name of the uploaded file
      return this.http.post(this.apiService.Parse.serverURL + '/files/' + file.name, file, options).map(response => response.json()).subscribe(
        response => {
          // Set the model `profileImage` value to the uploaded file URL
          this.model.profileImage = response.url;
        },
        error => alertify.error(error.message),
        () => {
          // Construct the payload with the required `gender` and `birthDate` values, along with the new `profileImage` value
          let payload = {
            "profileImage": this.model.profileImage,
            "gender": this.model.gender,
            "birthDate": this.model.birthDate
          };

          // When the image has been uploaded, fire form submission to save the new value to the user object
          this.putUser(payload);
        }
      );
    }
  }

  // Update the user
  public updateUser(data) {
    let payload = {
      "gender": this.model.gender,
      "birthDate": this.model.birthDate
    };

    $('button[type="submit"]').blur();

    for (let key of Object.keys(data.controls)) {
      // If the form control is dirty, or `profileImage` then add it to the payload
      if (data.controls[key].dirty || key == "profileImage") {
        // Add the dirty form control to the payload
        payload[key] = this.model[key]
        // payload[key] = data.controls[key].value

        // If the `email` control value doesn't match the value in the model, then add it to the payload
        if (key == "email" && data.controls.email.value != this.model.email) {
          payload["email"] = data.controls.email.value;

          // Set the `emailVerified` value to `false` before the form has been sumbitted so the view gets updated
          this.model.emailVerified = false;
        } else {
          // If the `email` value doesn't need updating, then remove it form the payload
          delete payload["email"];
        }

        if (key == "preferences") {
          // Delete the `preferences` object so it doesn't get submitted to the user object
          delete payload["preferences"];
          // Gather the values of the `preferences` model group and submit them
          this.putPreferences(data.controls.preferences.value);
        }

        if (key == "performanceState") {
          let performanceStatePayload: any;

          // Delete the `performanceState` object so it doesn't get submitted to the user object
          delete payload["performanceState"];
          // Gather the values of the `performanceState` model group and submit them, along with a pointer to the user
          performanceStatePayload = data.controls.performanceState.value;
          performanceStatePayload.user = {
            __type: "Pointer",
            objectId: this.apiService.Parse.User.current().id,
            className: "_User"
          };
          // Submit the new payload object
          this.postPerformanceState(performanceStatePayload);
        }
      }
    }

    this.putUser(payload);
  }

  // PUT the user data
  public putUser(payload) {
    let headers = new Headers();

    // Set the HTTP headers
    headers.append('Content-Type', 'application/json');
    headers.append('X-Parse-Application-Id', environment.parse.appId);
    headers.append('X-Parse-javascript-Key', environment.parse.jsKey);
    if (this.apiService.Parse.User.current()) {
      headers.append('X-Parse-Session-Token', this.apiService.Parse.User.current().get('sessionToken'));
    }

    let options = new RequestOptions({ headers: headers });

    return this.http.put(this.apiService.Parse.serverURL + '/users/' + this.apiService.Parse.User.current().id, payload, options).subscribe(
      response => alertify.success("Your profile has been updated"),
      error => alertify.error(error.message),
      () => {}
    );
  }

  public putPreferences(payload) {
    let headers = new Headers();

    // Set the HTTP headers
    headers.append('Content-Type', 'application/json');
    headers.append('X-Parse-Application-Id', environment.parse.appId);
    headers.append('X-Parse-javascript-Key', environment.parse.jsKey);
    if (this.apiService.Parse.User.current()) {
      headers.append('X-Parse-Session-Token', this.apiService.Parse.User.current().get('sessionToken'));
    }

    let options = new RequestOptions({ headers: headers });

    return this.http.put(this.apiService.Parse.serverURL + '/classes/UserPreferences/' + this.model.preferences.objectId, payload, options).subscribe(
      response => {},
      error => alertify.error(error.message),
      () => {}
    );
  }

  public postPerformanceState(payload) {
    let headers = new Headers();

    // Set the HTTP head
    headers.append('Content-Type', 'application/json');
    headers.append('X-Parse-Application-Id', environment.parse.appId);
    headers.append('X-Parse-javascript-Key', environment.parse.jsKey);
    if (this.apiService.Parse.User.current()) {
      headers.append('X-Parse-Session-Token', this.apiService.Parse.User.current().get('sessionToken'));
    }

    let options = new RequestOptions({ headers: headers });

    return this.http.post(this.apiService.Parse.serverURL + '/classes/UserPerformanceState', payload, options).subscribe(
      response => {},
      error => alertify.error(error.message),
      () => {}
    );
  }

  // Get the current user
  public getUser() {
    let headers = new Headers();
    let params = new URLSearchParams();

    // Set the HTTP headers
    headers.append('Content-Type', 'application/json');
    headers.append('X-Parse-Application-Id', environment.parse.appId);
    headers.append('X-Parse-javascript-Key', environment.parse.jsKey);
    if (this.apiService.Parse.User.current()) {
      headers.append('X-Parse-Session-Token', this.apiService.Parse.User.current().get('sessionToken'));
    }

    // Set up the params to include the relevant pointer objects
    params.append('include', 'performanceState,preferences');

    let options = new RequestOptions({ headers: headers, params: params });

    return this.http.get(this.apiService.Parse.serverURL + '/users/' + this.apiService.Parse.User.current().id, options)
    .map(response => response.json()).subscribe(
      response => {
        this.model = response;
      },
      error => alertify.error(error.message),
      () => {
        this.loaderService.setLoaded();
      }
    );
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/user/user.component.ts